import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ImpactSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.45119 6.80642C8.4872 3.54553 13.988 1.63178 21.2565 2.05934C21.625 2.08102 21.919 2.37502 21.9407 2.74354C22.3682 10.012 20.4545 15.5128 17.1936 18.5488C14.0236 21.5002 9.70686 22.003 5.44316 19.6998C5.39958 19.6762 5.34572 19.6841 5.31069 19.7191L3.24314 21.7867C2.95876 22.071 2.49768 22.071 2.21329 21.7867C1.9289 21.5023 1.9289 21.0412 2.21329 20.7568L4.28086 18.6892C4.31588 18.6542 4.32375 18.6003 4.30021 18.5568C1.99699 14.2931 2.49987 9.97636 5.45119 6.80642ZM20.4148 3.47726C13.7954 3.23738 9.0572 5.07066 6.51714 7.79886C4.14007 10.352 3.58297 13.8 5.3484 17.4118C5.36429 17.4443 5.39491 17.4671 5.43061 17.4731C5.46631 17.4791 5.50268 17.4674 5.52827 17.4418L14.817 8.15304C15.1014 7.86866 15.5625 7.86866 15.8469 8.15304C16.1313 8.43743 16.1313 8.89851 15.8469 9.1829L6.55811 18.4717C6.53252 18.4973 6.52086 18.5337 6.52682 18.5693C6.53278 18.605 6.55561 18.6357 6.58813 18.6516C10.2 20.417 13.648 19.8599 16.2011 17.4829C18.9293 14.9428 20.7626 10.2046 20.5227 3.58516C20.5206 3.52647 20.4735 3.47939 20.4148 3.47726Z"
        fill={color}
      />
    </svg>
  );
};

export { ImpactSvg };
